export function familyIncomeSourceIncongruence(occupation: string): (value: string) => string | null {
  return (value: string): string | null => {
    const error = 'familyIncomeSource';

    if(!value) {
      return null;
    }

    if(['DPU', 'IPU', 'OPU', 'DPR', 'IPR', 'OPR'].indexOf(occupation) !== -1 && value !== 'A') {
      return error;
    }

    if(['IMP', 'LPR', 'ART', 'COM'].indexOf(occupation) !== -1 && value !== 'B') {
      return error;
    }

    if(['PEN'].indexOf(occupation) !== -1 && value !== 'E') {
      return error;
    }

    if(['PEN'].indexOf(occupation) === -1 && value === 'E') {
      return error;
    }

    return null;
  }
}

export function incomeSavingsIncongruence(familyIncome: string, minimumInvestmentMonth: number): (value: number) => string | null {
  return (incomeSavings: number): string | null => {
    if(!familyIncome || !incomeSavings) {
      return null;
    }

    if(familyIncome === 'A') {
      return 'familyIncomeTooLow';
    }
    
    if(!minimumInvestmentMonth) {
      return null;
    }

    if(familyIncome === 'B' && evaluateFinances(incomeSavings, 15000, minimumInvestmentMonth) ||
      familyIncome === 'C' && evaluateFinances(incomeSavings, 30000, minimumInvestmentMonth) ||
      familyIncome === 'D' && evaluateFinances(incomeSavings, 45000, minimumInvestmentMonth) ||
      familyIncome === 'E' && evaluateFinances(incomeSavings, 70000, minimumInvestmentMonth)) {

      return 'incomeSavingsCoherence';
    }

    return null;

    function evaluateFinances(incomeSavings: number, multipier: number, minimumInvestmentMonth: number): boolean {
      return (incomeSavings * multipier / 100) <= (minimumInvestmentMonth * 12);
    }
  }
}
